export default __webpack_public_path__ + "static/media/pt_gap.956eb2a7.svg";